"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediumCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Image = require("../Image");

var _Text = require("../Text");

var _CardTag = require("./CardTag");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * `MediumCard` is a card with one image one tall image, and text for title and subtitle
 * at the bottom.
 */
var MediumCard = function MediumCard(_ref) {
  var image = _ref.image,
      title = _ref.title,
      subtitle = _ref.subtitle,
      tag = _ref.tag,
      rest = _objectWithoutProperties(_ref, ["image", "title", "subtitle", "tag"]);

  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    width: "280px",
    height: "370px",
    position: "relative"
  }, rest), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "0",
    borderRadius: "4px",
    overflow: "hidden"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({}, typeof image === "string" ? {
    src: image
  } : image, {
    alt: title,
    height: "100%",
    width: "auto"
  })), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    style: {
      background: "linear-gradient(rgba(0, 0, 0, 0), rgba(0,0,0,1))",
      opacity: 0.15
    },
    position: "absolute",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    position: "absolute",
    bottom: 1.5,
    left: 1.5
  }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "subtitle",
    color: "white100"
  }, title), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "text",
    color: "white100"
  }, subtitle)), !!tag && /*#__PURE__*/_react.default.createElement(_CardTag.CardTag, _extends({}, tag, {
    position: "absolute",
    top: 1.5,
    left: 1.5
  }))));
};

exports.MediumCard = MediumCard;
MediumCard.displayName = "MediumCard";
//# sourceMappingURL=MediumCard.js.map